export default __webpack_public_path__ + "static/media/1.de9717b7.jpeg";